



















import { defineComponent, reactive, toRefs, computed, ref, onMounted, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"
import http from "../plugins/http";
import moment from 'moment';

export interface Data {
  sumup_group_id: string
  curriculum_ids: number[]
}

export default defineComponent({
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sumup_group_id: null,
      curriculum_ids: []
    });

    const toSumupResultRankList = (curriculum_id: number | null) => {
      if(curriculum_id == null){
        context.root.$store.commit("setSumupResultCurriculumId", 0);
        context.root.$router.push(`/teacher_site/sumup_result_rank_list_total/${state.sumup_group_id}`).catch(err => {});
      }else{
        context.root.$store.commit("setSumupResultCurriculumId", curriculum_id);
        context.root.$router.push(`/teacher_site/sumup_result_rank_list_curriculum/${state.sumup_group_id}/${curriculum_id}`).catch(err => {});
      }
      location.reload();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const downloadExcel = async () => {
      
      alert("ダウンロードを開始します。受験者数が多い場合、時間がかかる場合があります。ウェブブラウザを閉じずにお待ちください。");

      await http.get(`/api/teacher/sumup_result_rank_list_total/download_excel/${context.root.$route.params.sumup_group_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `rank_result_${moment().format('Y-M-D')}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.sumup_group_id = context.root.$route.params.sumup_group_id;
      await http.get(`/api/teacher/sumup_result_rank_list_total/get_curriculum_ids?sumup_group_id=${state.sumup_group_id}`).then(response => {
        state.curriculum_ids = response.data.curriculum_ids;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
    });

    return {
      ...toRefs(state),
      downloadExcel,
      toSumupResultRankList
    };
  }
})
